import { useMemo } from 'react';
import type { PropertyPortalPublication } from 'src/api/generated';
import { useIntegrationActivityEvents } from 'src/modules/shared/hooks/api/integrations/integrations';
import { buildPropertySyncTimeline } from '../utils/property-sync-events.util';
import type { PropertySyncTimelineItem } from '../types/property-sync-events.type';

interface UsePropertySyncTimelineParams {
  enabled: boolean;
  propertyId: number;
  publications: PropertyPortalPublication[];
}

interface UsePropertySyncTimelineResult {
  items: PropertySyncTimelineItem[];
  loading: boolean;
}

export const usePropertySyncTimeline = ({
  enabled,
  propertyId,
  publications,
}: UsePropertySyncTimelineParams): UsePropertySyncTimelineResult => {
  const { events, loading } = useIntegrationActivityEvents(
    {
      propertyId,
      pageSize: 100,
    },
    enabled
  );

  const items = useMemo(
    () => buildPropertySyncTimeline(publications, events),
    [events, publications]
  );
  return {
    items,
    loading,
  };
};
